import axios from '@axios'

const PREFIX = '/parametrizacao'

export default {

  salvarParametrizacaoGeral(config) {
    return axios.post(`${PREFIX}/geral`, config)
  },

  uploadArquivoParametrizacao(tipo, file, onProgress) {
    const formData = new window.FormData()
    formData.append('file', file, file.name)

    return axios.post(`${PREFIX}/arquivos/${tipo}`, formData, {
      onUploadProgress: progressEvent => {
        if (!progressEvent.lengthComputable || typeof onProgress !== 'function') return
        onProgress(Math.min(100, Math.round((progressEvent.loaded * 100) / progressEvent.total)))
      },
    })
  },

  excluirArquivoParametrizacao(tipo) {
    return axios.delete(`${PREFIX}/arquivos/${tipo}`)
  },

  getParemtrizacaoGeral() {
    return axios.get(`${PREFIX}/geral`)
  },

  getEmailsPadraoContratada() {
    return axios.get(`${PREFIX}/emails-padrao-contratada`)
  },

  getMeiosPagamentoAtivos() {
    return axios.get(`${PREFIX}/meios-pagamento-ativos`)
  },

  getUrlArquivo() {
    return axios.get(`${PREFIX}/url-arquivo`)
  },

  getUrlVideo() {
    return axios.get(`${PREFIX}/url-video`)
  },

  getUrlVideoPropagandaSazonal() {
    return axios.get(`${PREFIX}/url-video-propaganda-sazonal`)
  },

  getParametrizacaoResumida() {
    return axios.get(`${PREFIX}/parametrizacao-resumida`)
  },

  getAuditoriaStatus() {
    return axios.get(`${PREFIX}/auditoria-status`)
  },

  getUrlArquivoPortal() {
    return axios.get(`${PREFIX}/portal-proposta/url-arquivo`)
  },

  getArquivoApresentacaoPortal() {
    return axios.get(`${PREFIX}/portal-proposta/arquivo-apresentacao`, {
      responseType: 'arraybuffer',
    })
  },

  getUrlVideoPortal() {
    return axios.get(`${PREFIX}/portal-proposta/url-video`)
  },

  getUrlVideoPropagandaSazonalPortal() {
    return axios.get(`${PREFIX}/portal-proposta/url-video-propaganda-sazonal`)
  },

  getParametrizacaoResumidaPortal() {
    return axios.get(`${PREFIX}/portal-proposta/parametrizacao-resumida`)
  },
}
